export function hasOwnProperty(target: any, property: string) {
	return Object.prototype.hasOwnProperty.call(target, property);
}
